$(document).ready(function () {
  $('#main').on('click', '.banner-generator a.ajax-link', function (event) {
    event.preventDefault();
    var request = event.currentTarget.dataset.uri;
    $.ajax({
      url: request,
      beforeSend: function () {
        $('.banner-generator').append('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>');
      },
      complete: function () {
        $('.spinner').remove();
      },
      success: function (response) {
        $('.banner-generator').replaceWith(response);
        initFancybox(response);
      }
    });
  });
});

function initFancybox(response) {
  var $jsBannerGenerator = $('.js-bannerGenerator');
  var $contentWrapper = $('.fancy-content-wrapper');
  var $textInputs = $contentWrapper.find('input[type=text]');
  $jsBannerGenerator.fancybox({
    smallBtn: true,
    toolbar: false,
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails'
      },
      de: {
        CLOSE: 'Schliessen',
        NEXT: 'Weiter',
        PREV: 'Zurück',
        ERROR: 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.',
        PLAY_START: 'Diaschau starten',
        PLAY_STOP: 'Diaschau beenden',
        FULL_SCREEN: 'Vollbild',
        THUMBS: 'Vorschaubilder'
      }
    },
    afterLoad: function () {
      var contentBackup = $contentWrapper.html();
      var loading = false;
      var fireAfterDebounce = debounce(function () {
        var $form = $('.fancybox-is-open').find('.fancyForm');
        var formDataArray = $form.serializeArray();
        [].forEach.call(formDataArray, function (formInput) {
          if (formInput['name'] === 'tx_messebanner_messebanner[preview]') {
            formInput['value'] = '1';
          }
        });
        var url = $form.attr('action');
        $.ajax({
          url: url + '&type=969',
          type: 'post',
          data: $.param(formDataArray),
          success: function (customResponse) {
            $('.js-previewImage').attr('src', customResponse);
          },
          complete: function () {
            $('.spinner').remove();
            loading = false;
            $('.js-imageOverlay').removeClass('image__overlay--active');
            var showResetButton = false;
            $textInputs.each(function () {
              if (this.value.trim() !== '') {
                showResetButton = true;
              }
            });
            changeResetButtonVisibility(showResetButton);
          }
        });
      }, 400);

      // submit form
      $contentWrapper.on('input change', 'input[type=text]', function () {
        if (!loading) {
          $('.js-imageOverlay').append('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>').addClass('image__overlay--active');
          loading = true;
        }
        fireAfterDebounce();
      });

      $contentWrapper.on('submit', '.fancyForm', function (event) {
        event.preventDefault();
        var url = $(this).attr('action');
        $.ajax({
          url: url + '&type=969',
          type: 'post',
          data: $(this).serialize(),
          success: function (customResponse) {
            $contentWrapper.html(customResponse);
          }
        });
      });
      // step back
      $contentWrapper.on('click', '.step-back', function (event) {
        event.preventDefault();
        $contentWrapper.html(contentBackup);
      });
    },
    afterClose: function () {
      // reset
      $('.banner-generator').replaceWith(response);
      initFancybox(response);
    }
  });
}

function changeResetButtonVisibility(showButton) {
  if (showButton) {
    $('.js-resetButton').show();
  } else {
    $('.js-resetButton').hide();
  }
}

function debounce(debounceFunction, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) debounceFunction.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) debounceFunction.apply(context, args);
  };
}
